module.exports = __webpack_public_path__ + "static/media/YAB.2a20ee08.jpg";